import React from "react";
import { Breadcrumbs } from "@blueprintjs/core";

const Breadcrumb=({breadcrumbItems, extraStyle})=>{
    let style = "gray-bg no-top-border"
    if(extraStyle){
      style = `${style} ${extraStyle}`
    }
    return(
        <section className={style}>
          <div className="main-container">
            <div className="content-wrapper has-breadcrumb">
              <Breadcrumbs
                collapseFrom="start"
                items={breadcrumbItems}
                className="breadcrumb"
              />
            </div>
          </div>
        </section>
    )
}

export default Breadcrumb;